<template>
  <div>
    <Breadcrumb :breadcrumb="breadcrumb"></Breadcrumb>
    <h5 class="title is-5">{{ $t("users.info") }}</h5>
    <vue-element-loading
      :active="isLoading"
      spinner="spinner"
      text="Loading..."
    />
    <Function
      v-if="user"
      :isDelete="user.delete_flag"
      :isMfa="user.mfa"
      :userName="user.userName"
      @deleteUser="deleteUser"
      @disableMfa="disableMfa"
    />
    <UsersInformation :user="user" />
  </div>
</template>
<script>
import Breadcrumb from "@/components/Breadcrumb.vue";
import imsr from "@/imsr-api";
import imsrc from "@/imsr-common";
import VueElementLoading from "vue-element-loading";
import UsersInformation from "@/views/Users/UserView/userInformation.vue";
import Function from "@/views/Users/UserView/function.vue";
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";

export default {
  components: {
    Breadcrumb,
    VueElementLoading,
    UsersInformation,
    Function,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const userId = route.query.userId;
    const user = ref({});
    const isLoading = ref(false);
    const breadcrumb = ref([
      { title: "Admin", path: "#", isActive: true },
      { title: "Users List", path: { name: "usersList" } },
      { title: "User Information", path: "#", isActive: true },
    ]);

    const fetchUser = async (userId) => {
      isLoading.value = true;
      try {
        const params = {
          tenantId: store.getters.tenantId,
          userId: userId,
        };
        const res = await imsr.imsrGetApi("/users/userInfo", params);
        user.value = {
          userId: res.userId,
          userName: res.userName,
          userRole: res.userRole,
          lastLogin: imsrc.dateFormat(res.lastLogin),
          created_at: imsrc.dateFormat(res.created_at),
          projects: res.projects,
          delete_flag: res.delete_flag,
          project_count: res.projects.length,
          mfa: res.cognito.mfa,
        };
      } catch (e) {
        router.push({ name: "InternalServerError" });
      } finally {
        isLoading.value = false;
      }
    };

    const deleteUser = async () => {
      try {
        const params = {
          tenantId: store.getters.tenantId,
          userId: userId,
        };
        await imsr.imsrDeleteApi("/users/delete", params);
        router.push({ name: "usersList" });
      } catch (e) {
        router.push({ name: "InternalServerError" });
      }
    };

    const disableMfa = async () => {
      try {
        const params = {
          tenantId: store.getters.tenantId,
          userId: userId,
        };
        await imsr.imsrPostApi("/users/adminDisableMfa", params);
      } catch (e) {
        router.push({ name: "InternalServerError" });
      } finally {
        reloadUser();
      }
    };
    const reloadUser = () => {
      if (userId) {
        fetchUser(userId);
      }
    };

    onMounted(() => {
      if (userId) {
        fetchUser(userId);
      }
    });

    return {
      user,
      isLoading,
      breadcrumb,
      deleteUser,
      disableMfa,
    };
  },
};
</script>
